import React from 'react';
import { useAppContext } from '@/context/AppContext';
import FieldGroup from '@/components/FieldGroup';
import SectionTitle from '@/components/SectionTitle';
import CheckboxGroup from '../CheckboxGroup';

function Step3Integrations() {
  const { projectDraft, dispatch } = useAppContext();
  
  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { [name]: value } });
  };
  
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { [name]: checked } });
  };
  
  return (
    <div>
      <SectionTitle title="Step 3: Integrations" subtitle="Connect third-party services to your application." />
      <div className="space-y-6">
        {/* Simple radio button examples. Would be better as custom components. */}
        <FieldGroup label="Code Storage"><input type="text" value="GitHub" readOnly className="mt-1 block w-full rounded-md border-gray-300 shadow-sm bg-gray-100 sm:text-sm" /></FieldGroup>
        <FieldGroup label="Hosting"><input type="text" value="Cloudflare" readOnly className="mt-1 block w-full rounded-md border-gray-300 shadow-sm bg-gray-100 sm:text-sm" /></FieldGroup>
        <FieldGroup label="AI"><input type="text" value="OpenAI" readOnly className="mt-1 block w-full rounded-md border-gray-300 shadow-sm bg-gray-100 sm:text-sm" /></FieldGroup>
        
        <FieldGroup label="Database">
          <div className="flex space-x-4"><label><input type="radio" name="database" value="ncb" checked={projectDraft.database === 'ncb'} onChange={handleRadioChange} /> NCB</label><label><input type="radio" name="database" value="supabase" checked={projectDraft.database === 'supabase'} onChange={handleRadioChange} /> Supabase</label></div>
        </FieldGroup>

        <div className="mt-4 flex items-center">
          <input type="checkbox" name="pwaEnabled" id="pwaEnabled" checked={projectDraft.pwaEnabled || false} onChange={handleCheckboxChange} className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
          <label htmlFor="pwaEnabled" className="ml-2 block text-sm text-gray-900">Enable PWA Features</label>
        </div>
      </div>
    </div>
  );
}

export default Step3Integrations;